import { FILTER_TYPES } from './constants';

class MetricState {
  static transition(currentMetric, newMetric) {
    // If same metric, reset to default state
    if (currentMetric === newMetric) {
      return {
        requiresUIUpdate: true,
        requiresFilterUpdate: true,
        newUIState: prev => ({ ...prev, activeMetric: 'total' }),
        newFilterState: prev => ({ ...prev, [FILTER_TYPES.STATUS]: [], created_at: null })
      };
    }

    // Base transition requires UI update
    const transition = {
      requiresUIUpdate: true,
      requiresFilterUpdate: true,
      newUIState: prev => ({
        ...prev,
        activeMetric: newMetric
      })
    };

    // Determine filter updates based on metric type
    switch (newMetric) {
      case 'newThisWeek':
        transition.newFilterState = prev => ({
          ...prev,
          [FILTER_TYPES.STATUS]: [],
          created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
        });
        break;

      case 'submitted':
      case 'active':
      case 'waitlist':
        transition.newFilterState = prev => ({
          ...prev,
          [FILTER_TYPES.STATUS]: [newMetric],
          created_at: null
        });
        break;

      case 'total':
        transition.newFilterState = prev => ({
          ...prev,
          [FILTER_TYPES.STATUS]: [],
          created_at: null
        });
        break;

      default:
        transition.requiresFilterUpdate = false;
    }

    return transition;
  }
}

export default MetricState; 